import Sticky from "react-stickynode"
import { useTranslation } from "next-i18next"
import dynamic from "next/dynamic"
import MetaData from "@/common/components/MetaData"
import SectionLine from "@/common/components/_UI/SectionLine"
import { assoc, pipe } from "lodash/fp"
import AssetProDark from "@/common/assets/image/products/icons/AssetProDark.svg"

import Button from "@/common/components/_UI/ButtonNew"
import { UserRecommendSection } from "./wallet"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))

import { ProductNames } from "@/common/data/Products"
import Footer from "@/containers/common/FooterNew"
import { DarkBGWrapper, LayoutWrapper } from "@/common/components/LayoutStyle"
import Description, {
  CardWrapper,
  SubDescContent,
  SubDescLayoutWrapper,
  SubDescription,
  SubDescWrapper
} from "@/common/components/Description"
import { ProductBanner } from "@/common/components/ProductBanner"
import NextImg from "@/common/components/NextImg"

import SubDesc1 from "@/common/assets/image/assetPro/description/SubDesc1.svg"
import SubDesc2 from "@/common/assets/image/assetPro/description/SubDesc2.svg"
import SubDesc3 from "@/common/assets/image/assetPro/description/SubDesc3.svg"
import SubDesc4 from "@/common/assets/image/assetPro/description/SubDesc4.svg"
import SubDesc5 from "@/common/assets/image/assetPro/description/SubDesc5.svg"
import SubDesc6 from "@/common/assets/image/assetPro/description/SubDesc6.svg"
import SubDesc7 from "@/common/assets/image/assetPro/description/SubDesc7.svg"
import SubDesc8 from "@/common/assets/image/assetPro/description/SubDesc8.svg"
import featureBanner1 from "@/common/assets/image/assetPro/featureBanner/image1.avif"
import featureBanner2 from "@/common/assets/image/assetPro/featureBanner/image2.avif"
import featureBanner3 from "@/common/assets/image/assetPro/featureBanner/image3.avif"
import featureBanner4 from "@/common/assets/image/assetPro/featureBanner/image4.avif"
import featureBanner5 from "@/common/assets/image/assetPro/featureBanner/image5.avif"
import featureBanner6 from "@/common/assets/image/assetPro/featureBanner/image6.avif"
import featureBanner7 from "@/common/assets/image/assetPro/featureBanner/image7.avif"
import featureBanner8 from "@/common/assets/image/assetPro/featureBanner/image8.avif"

import Chloe from "@/common/assets/image/products/wallet/application/Chloe.svg"
import Estelle from "@/common/assets/image/products/wallet/application/Estelle.svg"
import Olivia from "@/common/assets/image/products/wallet/application/Olivia.svg"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import LazyLoadComponent from "@/common/components/LazyLoadComponent"
import styled from "styled-components"
import { theme } from "@/common/Mixin"
const Fade = require("react-reveal/Fade")

const AssetProPage = () => {
  const { t } = useTranslation(["assetPro"])
  const UserTestimonialData = [
    {
      company: t("userTestimonials.1.title"),
      name: t("userTestimonials.1.name"),
      description: t("userTestimonials.1.desc"),
      image: Olivia
    },
    {
      company: t("userTestimonials.2.title"),
      name: t("userTestimonials.2.name"),
      description: t("userTestimonials.2.desc"),
      image: Estelle
    },
    {
      company: t("userTestimonials.3.title"),
      name: t("userTestimonials.3.name"),
      description: t("userTestimonials.3.desc"),
      image: Chloe
    }
  ]

  return (
    <AssetProWrapper>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/products/asset-pro"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/products/asset-pro"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/products/asset-pro"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/products/asset-pro"
          }
        ]}
      />

      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <DarkBGWrapper></DarkBGWrapper>
      <LayoutWrapper>
        <ProductBanner
          icon={AssetProDark.src}
          bannerType={ProductNames.AssetPro}
          title={t("banner.productName")}
          titleh1={t("banner.title")}
          description={t("banner.description")}
          primaryButton={{
            content: t("cta.primary"),
            arrowType: "none",
            href: "#contact-us",
            target: "_self"
          }}
          subtleButton={{
            content: t("cta.subtle"),
            arrowType: "none",
            href: "#features",
            target: "_self"
          }}
        />
        <SectionLine />
        <div id="features" />
        <Description
          backgroundType="none"
          items={[
            {
              titles: [
                {
                  text: t("description.topTitle"),
                  textType: "h4",
                  textClass: "primary"
                },
                {
                  text: t("description.mainTitle"),
                  textType: "h3"
                }
              ],
              subDescriptions: [
                {
                  icon: SubDesc1,
                  title: t("subDesc.1.title"),
                  content: t("subDesc.1.description")
                },
                {
                  icon: SubDesc2,
                  title: t("subDesc.2.title"),
                  content: t("subDesc.2.description")
                },
                {
                  icon: SubDesc3,
                  title: t("subDesc.3.title"),
                  content: t("subDesc.3.description")
                },
                {
                  icon: SubDesc4,
                  title: t("subDesc.4.title"),
                  content: t("subDesc.4.description")
                }
              ].map<SubDescription>(
                pipe(
                  assoc("imageStyle", { width: "120px" }),
                  assoc("imageWrapperStyle", { margin: "1em" })
                )
              ),

              wide: true
            }
          ]}
        />
        <Description
          backgroundType="none"
          items={[
            {
              subDescriptions: [
                {
                  icon: SubDesc5,
                  title: t("subDesc.5.title"),
                  content: t("subDesc.5.description")
                },
                {
                  icon: SubDesc6,
                  title: t("subDesc.6.title"),
                  content: t("subDesc.6.description")
                },
                {
                  icon: SubDesc7,
                  title: t("subDesc.7.title"),
                  content: t("subDesc.7.description")
                },
                {
                  icon: SubDesc8,
                  title: t("subDesc.8.title"),
                  content: t("subDesc.8.description")
                }
              ].map<SubDescription>(
                pipe(
                  assoc("imageStyle", { width: "120px" }),
                  assoc("imageWrapperStyle", { margin: "1em" })
                )
              ),
              wide: true
            }
          ]}
        />
        <div style={{ display: "flex", justifyContent: "center", gap: "1em" }}>
          <Button
            arrowType="none"
            content={t("cta.primary")}
            style={{ minWidth: "0" }}
            href="#contact-us"
            target="_self"
          />
          <Button
            styleType="subtle"
            arrowType="none"
            content={t("cta.subtle")}
            style={{ minWidth: "0" }}
            href="#feature-details"
            target="_self"
          />
        </div>
        <div id="feature-details" />
        <ProductBanner
          comp2={<NextImg alt="featureBanner1" src={featureBanner1} />}
          title={t("subBanner1.title")}
          titleType="primary"
          titleh1={t("subBanner1.content")}
          description={t("subBanner1.description")}
        />
        <ProductBanner
          comp2={<NextImg alt="featureBanner2" src={featureBanner2} />}
          title={t("subBanner2.title")}
          titleType="primary"
          titleh1={t("subBanner2.content")}
          description={t("subBanner2.description")}
          checkList={[
            {
              list: [
                {
                  title: t("subBanner2.checkList.1.title"),
                  description: t("subBanner2.checkList.1.desc")
                },
                {
                  title: t("subBanner2.checkList.2.title"),
                  description: t("subBanner2.checkList.2.desc")
                }
              ]
            }
          ]}
        />
        <ProductBanner
          comp2={<NextImg alt="featureBanner3" src={featureBanner3} />}
          title={t("subBanner3.title")}
          titleType="primary"
          titleh1={t("subBanner3.content")}
          description={t("subBanner3.description")}
          checkList={[
            {
              list: [
                {
                  title: t("subBanner3.checkList.1.title"),
                  description: t("subBanner3.checkList.1.desc")
                },
                {
                  title: t("subBanner3.checkList.2.title"),
                  description: t("subBanner3.checkList.2.desc")
                },
                {
                  title: t("subBanner3.checkList.3.title"),
                  description: t("subBanner3.checkList.3.desc")
                }
              ]
            }
          ]}
        />
        <ProductBanner
          comp2={<NextImg alt="featureBanner4" src={featureBanner4} />}
          title={t("subBanner4.title")}
          titleType="primary"
          titleh1={t("subBanner4.content")}
          description={t("subBanner4.description")}
          checkList={[
            {
              list: [
                {
                  title: t("subBanner4.checkList.1.title"),
                  description: t("subBanner4.checkList.1.desc")
                },
                {
                  title: t("subBanner4.checkList.2.title"),
                  description: t("subBanner4.checkList.2.desc")
                }
              ]
            }
          ]}
        />
        <ProductBanner
          comp2={<NextImg alt="featureBanner5" src={featureBanner5} />}
          title={t("subBanner5.title")}
          titleType="primary"
          titleh1={t("subBanner5.content")}
          description={t("subBanner5.description")}
          checkList={[
            {
              list: [
                {
                  title: t("subBanner5.checkList.1.title"),
                  description: t("subBanner5.checkList.1.desc")
                },
                {
                  title: t("subBanner5.checkList.2.title"),
                  description: t("subBanner5.checkList.2.desc")
                },
                {
                  title: t("subBanner5.checkList.3.title"),
                  description: t("subBanner5.checkList.3.desc")
                }
              ]
            }
          ]}
        />
        <SectionLine />
        <div id="services" />
        <Description
          backgroundType="none"
          items={[
            {
              titles: [
                {
                  text: t("middleDescription.topTitle"),
                  textType: "h4",
                  textClass: "primary"
                },
                {
                  text: t("middleDescription.mainTitle"),
                  textType: "h3"
                },
                {
                  text: t("middleDescription.desc"),
                  textType: "span"
                }
              ],
              wide: true
            }
          ]}
        />
        <ProductBanner
          comp2={<NextImg alt="featureBanner6" src={featureBanner6} />}
          title={t("subBanner6.title")}
          titleType="primary"
          titleh1={t("subBanner6.content")}
          description={t("subBanner6.description")}
          primaryButton={{
            content: t("subBanner6.cta.primary"),
            arrowType: "none",
            href: "#contact-us",
            target: "_self"
          }}
          subtleButton={{
            content: t("subBanner6.cta.subtle"),
            arrowType: "right",
            href: "/products/wallet-builder",
            target: "_self"
          }}
        />
        <ProductBanner
          comp2={<NextImg alt="featureBanner7" src={featureBanner7} />}
          title={t("subBanner7.title")}
          titleType="primary"
          titleh1={t("subBanner7.content")}
          checkList={[
            {
              list: [
                {
                  title: t("subBanner7.checkList.1.title"),
                  description: t("subBanner7.checkList.1.desc")
                },
                {
                  title: t("subBanner7.checkList.2.title"),
                  description: t("subBanner7.checkList.2.desc")
                }
              ]
            }
          ]}
          description={t("subBanner7.description")}
          primaryButton={{
            content: t("subBanner7.cta.primary"),
            arrowType: "none",
            href: "#contact-us",
            target: "_self"
          }}
          subtleButton={{
            content: t("subBanner7.cta.subtle"),
            arrowType: "right",
            href: "/products/compliance-pro",
            target: "_self"
          }}
        />
        <ProductBanner
          comp2={<NextImg alt="featureBanner8" src={featureBanner8} />}
          title={t("subBanner8.title")}
          titleType="primary"
          titleh1={t("subBanner8.content")}
          description={t("subBanner8.description")}
          checkList={[
            {
              list: [
                {
                  title: t("subBanner8.checkList.1.title"),
                  description: t("subBanner8.checkList.1.desc")
                },
                {
                  title: t("subBanner8.checkList.2.title"),
                  description: t("subBanner8.checkList.2.desc")
                }
              ]
            }
          ]}
          primaryButton={{
            content: t("subBanner8.cta.primary"),
            arrowType: "none",
            href: "#contact-us",
            target: "_self"
          }}
          // * wait for 'solutions/web3-commerce' page to be online
          // subtleButton={{
          //   content: t("subBanner8.cta.subtle"),
          //   arrowType: "right",
          // href: "solutions/web3-commerce",
          // target: "_self"
          // }}
        />
        <SectionLine />
        <UserRecommendSection
          titleText={t("userTestimonials.title")}
          subtitleText={t("userTestimonials.subtitle")}
          UserTestimonialData={UserTestimonialData}
        >
          <Button
            arrowType="none"
            content={t("recommend.cta")}
            style={{ minWidth: "0" }}
            href="#contact-us"
          />
        </UserRecommendSection>
        <div id="contact-us" />
        <LazyLoadComponent
          skeletonProps={{
            width: "75%"
          }}
          props={{
            page: "asset-pro",
            description: t("contactUs.title"),
            slogan: t("contactUs.slogan"),
            body: t("contactUs.description"),
            style: { height: 755 }
          }}
          component={() =>
            import("@/common/components/ContactUs/ContactUsSection")
          }
        />
        <Footer />
      </LayoutWrapper>
    </AssetProWrapper>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contactUs",
      "assetPro"
    ]))
  }
})

export default AssetProPage

const AssetProWrapper = styled.div`
  & ${CardWrapper} {
    max-width: 80vw;
  }

  & ${SubDescLayoutWrapper} {
    @media (${theme.md}) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1em;
    }

    @media (${theme.sm}) {
      display: grid;
      grid-template-columns: 1fr;
    }
  }

  & ${SubDescWrapper} {
    padding: 1em;
  }

  & ${SubDescContent} {
    width: initial;
    @media (${theme.lg}) {
      display: initial;
    }
  }
`
